export default "__VITE_ASSET__B9rNQZ8v__"